import Hls, { Events } from "hls.js";
import React from "react";

interface IProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
  src?: string;
}

const Video = React.forwardRef<HTMLVideoElement, IProps>((props, ref) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);

  React.useImperativeHandle(ref, () => videoRef.current as HTMLVideoElement);

  React.useEffect(() => {
    if (props.src?.endsWith("m3u8")) {
      const video = videoRef?.current;
      if (video && Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(props.src);
        hls.attachMedia(video);
        hls.on(Events.MANIFEST_PARSED, () => {
          if (props.autoPlay) {
            video.play();
          }
        });
        return () => {
          hls.destroy(); // 清理资源
        };
      } else if (video && video.canPlayType?.("application/vnd.apple.mpegurl")) {
        // Safari / iOS 原生支持
        video.src = props.src;
        video.addEventListener("loadedmetadata", () => {
          if (props.autoPlay) {
            video.play();
          }
        });
      } else {
        console.error("This browser does not support HLS.");
      }
    }
  }, [props.src, props.autoPlay]);

  return (
    // eslint-disable-next-line no-restricted-syntax
    <video
      {...props}
      ref={videoRef}
      preload={props.preload ?? "metadata"} // iOS 上默认预加载导致多视频情况下特别慢，改为默认 `metadata`
      disablePictureInPicture
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsInline={true}
      x5-playsinline="true"
    />
  );
});

Video.displayName = "Video";

export default Video;
